export const buildNumber = '20260417.1';
export const version = 'main';
export const latestCommit = '94b90ab3c4769a5237310c6194fcc69a251145a3';
